<template>
	<div class="container">
		<div class="header">
			<div >
				<router-link to="/"><img src="../../assets/image/login/login_logo.png" style="width: 123px;height: 54px;" /></router-link>
			</div>
			<div class="menu" style="display: flex;">
				<div style="display: flex;align-items: center;">
					<img src="../../assets/image/login/ico1.png" style="width: 19px;height: 19px;margin-left: 5px;" alt="">
					<span class="unload"><a style="color: rgb(255, 171, 153);" rel="noopenner noreferrer" target="_blank"  :href=href>APP下载</a></span>
				</div>
				<div style="margin-left: 20px;display: flex;align-items: center;">
					<img src="../../assets/image/login/ico2.png" style="width: 19px;height: 19px;" alt="">
					<span style="font-size: 14px;">{{info.tel}}</span>
				</div>

			</div>
		</div>
	</div>
</template>
<!--window.origin+-->
<script>
	export default{
		data(){
			return{
				href:window.origin+"/wyyd_1.0.apk"
			}
		},
		props: ['info']
	}
</script>

<style lang="less">
	.header{
		background-color: #fff;
		// height: 50px;
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 8px 20px;
		box-sizing: border-box;
		img{
			width: 200px;
			height: 100%;
		}
		.menu{
			margin-right: 20px;
			span{
				cursor: pointer;
				color: #3b3b3b;
				margin-left: 5px;
			}

		}
	}
</style>
